import { render, staticRenderFns } from "./product_list.vue?vue&type=template&id=789f06bc&scoped=true&"
import script from "./product_list.vue?vue&type=script&lang=js&"
export * from "./product_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789f06bc",
  null
  
)

export default component.exports